import React from "react";
import { Image } from "react-bootstrap";

import "./AvatarGroup.scss";

function AvatarGroup({ avatars }: { avatars?: string[] }) {
  return (
    <div className="avatar-group d-flex align-items-center">
      {avatars?.slice(0, 3).map((avatar, i) => (
        <div
          key={'avatar-' + i}
          className="item-wrapper rounded-pill position-relative d-flex align-items-center justify-content-center"
          style={{
            zIndex: i + 1,
            left: i * -10,
          }}
        >
          <div
            className="img-wrapper rounded-pill d-flex align-items-center justify-content-center"
            style={{
              background: i === 2 ? "#ffc6c5" : i === 1 ? "#fceadc" : "#dfd1cb",
            }}
          >
            <Image
              src={avatar}
              key={i}
              height={20}
              width={20}
              className="rounded-pill"
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default AvatarGroup;
